var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuppliers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5833333333333334,0,0,0.5833333333333334,0,0)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M24,21.3a3,3,0,0,0-1.17-2.38,15.64,15.64,0,0,0-7.59-2.81A.27.27,0,0,1,15,15.9a.25.25,0,0,1,.13-.27A7,7,0,0,0,19,9.4v-1a.25.25,0,0,1,.25-.25h.25a.75.75,0,0,0,0-1.5h-.32a.24.24,0,0,1-.25-.21,7,7,0,0,0-3.14-4.91.27.27,0,0,0-.23,0,.28.28,0,0,0-.15.17L14.2,6.1a.75.75,0,0,1-.72.55l-.2,0a.75.75,0,0,1-.53-.92L14.06.85A.26.26,0,0,0,14,.56,5,5,0,0,0,10,.56a.26.26,0,0,0-.11.29L11.2,5.71a.75.75,0,0,1-.53.92.76.76,0,0,1-.92-.53L8.56,1.67a.28.28,0,0,0-.15-.17.27.27,0,0,0-.23,0A7,7,0,0,0,5,6.44a.24.24,0,0,1-.24.21H4.48a.75.75,0,0,0,0,1.5h.25A.25.25,0,0,1,5,8.4v1a7,7,0,0,0,3.83,6.23.25.25,0,0,1,.13.27.25.25,0,0,1-.21.21,15.64,15.64,0,0,0-7.59,2.81A3,3,0,0,0,0,21.3v1.6a1,1,0,0,0,2,0V21.3a1,1,0,0,1,.37-.79,10.53,10.53,0,0,1,2.28-1.29.24.24,0,0,1,.23,0,.26.26,0,0,1,.12.21v4.2a.25.25,0,0,0,.25.25H11a.25.25,0,0,0,.25-.25V20.7a.24.24,0,0,0-.07-.17L9.22,18.46a.27.27,0,0,1-.05-.26A.26.26,0,0,1,9.38,18,23.05,23.05,0,0,1,12,17.9a22.87,22.87,0,0,1,2.59.14.24.24,0,0,1,.21.16.27.27,0,0,1,0,.26l-1.94,2.07a.24.24,0,0,0-.06.17v2.95a.25.25,0,0,0,.25.25h5.75a.25.25,0,0,0,.25-.25v-4.2a.25.25,0,0,1,.11-.21.24.24,0,0,1,.23,0,10.28,10.28,0,0,1,2.28,1.29,1,1,0,0,1,.38.79v1.6a1,1,0,0,0,2,0ZM7,9.4v-1a.25.25,0,0,1,.25-.25h9.5A.25.25,0,0,1,17,8.4v1a5,5,0,1,1-10,0Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.98,
    cy: 9.65,
    r: 1,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.98,
    cy: 9.65,
    r: 1,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.92,13.15a2.17,2.17,0,0,0,.44-.19.64.64,0,0,0-.31-1.2h-2a.64.64,0,0,0-.62.49.63.63,0,0,0,.32.71,1.63,1.63,0,0,0,.43.18A3.12,3.12,0,0,0,12.92,13.15Z",
    fill: "currentColor"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuppliers);
export default __webpack_public_path__ + "static/media/suppliers.1c89a0b0d8944ef08d7d05ad9ee79ed4.svg";
export { ForwardRef as ReactComponent };